import { PriceRuleBase } from ".";
import { MediaCommandModel } from "../media-model";

export class PriceRuleCommand extends PriceRuleBase {
    public medias: MediaCommandModel[];
    public children: PriceRuleCommand[];
}